import { IBaseResponseModel } from './base.model';
import { ICoordinatesModel } from './coordinates.model';
import { IParkingModel } from './parking.model';

export interface IFineFixationModel {
  coordinates: ICoordinatesModel;
  zone: { uuid: string };
  parkings: IParkingModel[];
  images: IFineFixationImagesModel;
  complex: IFineFixationComplex;
  complexId: string;
  uuid: string;
  carno: string;
  dt: string;
  uploadTimestamp: string;
  metadataXmlUuid: string;
  place: string;
  canEdit: boolean;
  status: FineFixationStatusType;
}

export interface IFineFixationComplex {
  PZT: boolean;
  complexCertificateMetrology: string;
  complexExpirationDate: string;
  complexId: string;
  complexModel: string;
  complexType: string;
  fix: string;
}

export interface IFineFixationImagesModel {
  carImageBase64?: string;
  carImageId?: string;
  plateImageBase64?: string;
  plateImageId?: string;
}

export interface IFineFixationResponseModel extends IBaseResponseModel {
  rec: IFineFixationModel[];
}

export interface IFineFixationFilterModel {
  page?: number;
  pageSize?: number;
  startDate?: number;
  endDate?: number;
  zones?: string[];
  query?: string;
}

export enum FineFixationStatusType {
  UNPROCESSED = 'unprocessed', // Необработанный
  ASSIGNED = 'assigned', // Назначенный
  CONFIRMED = 'confirmed', // Подтвержденный
  CORRECTED = 'corrected', // Исправленный
  UNCONFIRMED = 'unconfirmed', // Неподтвержденный
  AUTOMATIC = 'automatic', // Автоматический
  FINISHED = 'finished', // Автоматический
  CHECKED_AI = 'checked_ai', // Проверено ИИ
}
